import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from "@angular/core"
import { Observable, Subscription } from "rxjs"
import { Router, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from "@angular/router"
import { HelpersService } from "src/app/services/helpers.service"
import { environment } from "src/environments/environment"
import { AuthService } from "src/app/services/auth.service"

declare var require: any

@Component({
	selector: "app-navbar",
	templateUrl: "./navbar.component.html",
	styleUrls: ["./navbar.component.scss"]
})
export class NavbarComponent implements OnInit, OnDestroy {
	private showRight: boolean
	public currentUrl
	public activeTab = false
	public loading = false
	public canTranslate = environment.translate
	public version = require("../../../../../package.json").version
	public baseUrl = environment.MAIN_URL
	public assets_version = environment.ASSETS_VERSION
	public userData: any

	constructor(
		public router: Router,
		public helpersService: HelpersService,
		public authService: AuthService
	) {
		this.router.events.subscribe((event: Event) => {
			switch (true) {
				case event instanceof NavigationStart: {
					this.loading = true
					break
				}
				case event instanceof NavigationEnd:
				case event instanceof NavigationCancel:
				case event instanceof NavigationError: {
					this.loading = false
					break
				}
			}
		})
	}

	@ViewChild("submenuLink", { static: false }) submenuLink: ElementRef

	ngOnInit() {
		this.currentUrl = this.router.url
		this.authService.getUserData().subscribe(res => {
			this.userData = res
		})
	}

	ngOnDestroy() {}

	public toggleView() {}

	public get prod() {
		return environment.production
	}

	logout = () => this.authService.logout()
}
